/**
 * SegmentedTabs - iOS-Style Tab Navigation
 * 
 * Mockup-exact:
 * - iOS segmented control style
 * - NO pill tabs, NO gray block
 * - Active: underline + medium-bold text
 * - Clean white background
 * - Sticky on scroll
 */

import React from 'react';

export type TabId = 'menu' | 'info' | 'reviews';

interface Tab {
  id: TabId;
  label: string;
}

interface SegmentedTabsProps {
  activeTab: TabId;
  onTabChange: (tab: TabId) => void;
}

const tabs: Tab[] = [
  { id: 'menu', label: 'Speisekarte' },
  { id: 'info', label: 'Info' },
  { id: 'reviews', label: 'Bewertungen' },
];

export const SegmentedTabs: React.FC<SegmentedTabsProps> = ({
  activeTab,
  onTabChange,
}) => {
  return (
    <nav 
      className="sticky top-0 z-40"
      style={{ 
        background: 'rgba(255,255,255,0.92)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(0,0,0,0.06)',
      }}
    >
      <div className="flex">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className="flex-1 relative py-3.5 transition-colors"
              role="tab"
              aria-selected={isActive}
              style={{ WebkitTapHighlightColor: 'transparent' }}
            >
              <span 
                className={`text-sm transition-colors ${
                  isActive 
                    ? 'font-semibold' 
                    : 'font-medium'
                }`}
                style={{ 
                  color: isActive ? '#0E7F4F' : '#9CA3AF',
                }}
              >
                {tab.label}
              </span>
              
              {/* Active Underline — gradient */}
              <div 
                className="absolute bottom-0 left-1/2 -translate-x-1/2 h-[2.5px] rounded-full transition-colors duration-200"
                style={{
                  width: isActive ? '32px' : '0px',
                  background: isActive ? 'linear-gradient(90deg, #0E7F4F, #18B66A)' : '#0E7F4F',
                  opacity: isActive ? 1 : 0,
                }}
              />
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default SegmentedTabs;
